import React, { FC } from 'react';

import { IFAQ } from '../../../assets/interfaces/faqInterface/index';
import { Title } from '../../UI/title/Title';
import Wrapper from '../../UI/wrapper/Wrapper';
import FAQList from '../../faqList/FAQList';

import styles from './FAQSection.module.scss';

type TFAQ = {
    faqList: IFAQ[];
};

const FAQSection: FC<TFAQ> = ({ faqList }) => {
    const heading = 'Frequently Asked Questions';
    const excerpt =
        'Find quick, expert answers to common queries about our Ghost themes and templates in our FAQ section.';

    return (
        <section className={styles.faq}>
            <Wrapper className={styles.wrapper}>
                <div className={styles.faq__info}>
                    <Title text={heading} size="lg" className={styles.heading} />

                    <p className={`excerpt body-lg excerpt-wrap ${styles.excerpt} `}>{excerpt}</p>
                </div>
                <FAQList faqList={faqList} />
            </Wrapper>
        </section>
    );
};

export default FAQSection;
